import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';
import { ItemAddForm } from '../../../../constants/constant_form_names';
import {
  BATCH,
  BUNDLE,
  COUPON,
  DISCOUNT,
  GIFTCERTIFICATE,
  INVENTORY,
  MATRIX,
  NONINVENTORY,
  PROMOTION,
  SERIALIZED,
  SERVICE,
} from '../../../../constants/constant_item_types';

const selector = formValueSelector(ItemAddForm);

// const getEnableItemPartQuantityPreference = state => (
//   ((state.preference || {}).settings || {}).enable_item_part_quantity
// );

const getHasChildren = state => selector(state, 'has_children');

const getFormItemTypeId = state => selector(state, 'item_type');

const getFormParentItemTypeId = state => selector(state, 'parent_item_type');

const getFormParentItem = state => selector(state, 'parent_item') || { matrix_definition: {} };

const getFormCustomTabs = state => selector(state, 'custom_tabs') || [];
const getFormBarcodes = state => selector(state, 'barcodes') || [];
const getFormQrcodes = state => selector(state, 'qrcodes') || [];

export const getItemBarcodes = createSelector(
  [getFormBarcodes],
  (barcodes) => barcodes
);

export const getItemQrcodes = createSelector(
  [getFormQrcodes],
  (qrcodes) => qrcodes
);

export const showAllowDynamicLink = createSelector(
  [getFormItemTypeId],
  (itemTypeId) => {
    const itemTypes = [
      BATCH,
      BUNDLE,
      INVENTORY,
      MATRIX,
      NONINVENTORY,
      SERIALIZED,
      SERVICE,
    ];
    return itemTypes.indexOf(itemTypeId) > -1;
  }
);

export const showCreditType = createSelector(
  [getFormItemTypeId],
  (itemTypeId) => {
    const itemTypes = [GIFTCERTIFICATE];
    return itemTypes.indexOf(itemTypeId) > -1;
  }
);

export const showFacet = createSelector(
  [getFormItemTypeId],
  (itemTypeId) => {
    const itemTypes = [BATCH, BUNDLE, INVENTORY, SERIALIZED, MATRIX, SERVICE, GIFTCERTIFICATE, NONINVENTORY];
    return itemTypes.indexOf(itemTypeId) > -1;
  }
);

export const showDimension = createSelector(
  [getFormItemTypeId],
  (itemTypeId) => {
    const itemTypes = [BATCH, BUNDLE, INVENTORY, SERIALIZED, MATRIX];
    return itemTypes.indexOf(itemTypeId) > -1;
  }
);

export const showEnablePartQuantity = createSelector(
  [getFormItemTypeId],
  (itemTypeId) => {
    const itemTypes = [MATRIX, INVENTORY, NONINVENTORY];
    return itemTypes.indexOf(itemTypeId) > -1;
  }
);

export const showMatrixDefinition = createSelector(
  [getFormItemTypeId],
  (itemTypeId) => {
    const itemTypes = [MATRIX];
    return itemTypes.indexOf(itemTypeId) > -1;
  }
);

export const showReferencedConcession = createSelector(
  [getFormItemTypeId],
  (itemTypeId) => {
    const itemTypes = [PROMOTION, COUPON, DISCOUNT];
    return itemTypes.indexOf(itemTypeId) > -1;
  }
);

export const hasMatrixChildren = createSelector(
  [getHasChildren],
  (hasChildren) => {
    return hasChildren;
  }
);

export const showMatrixParentDetails = createSelector(
  [getFormParentItemTypeId],
  (parentItemTypeId) => {
    const itemTypes = [MATRIX];
    return itemTypes.indexOf(parentItemTypeId) > -1;
  }
);

export const showConsignment = createSelector(
  [getFormItemTypeId],
  (itemTypeId) => {
    const itemTypes = [BATCH, BUNDLE, INVENTORY, SERIALIZED, MATRIX];
    return itemTypes.indexOf(itemTypeId) > -1;
  }
);

export const showManualPromotion = createSelector(
  [getFormItemTypeId],
  (itemTypeId) => {
    const itemTypes = [PROMOTION];
    return itemTypes.indexOf(itemTypeId) > -1;
  }
);

export const getParentItemDetails = createSelector(
  [getFormParentItem],
  (parentItem) => {
    return parentItem;
  }
);

export const getCustomTabs = createSelector(
  [getFormCustomTabs],
  customTabs => customTabs,
);
